import React, {Component} from 'react';

import Modal from 'react-modal';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import constructName from '../../utils/constructName'

import '../../styles/profile.css'
import { Logo } from '../../shared/components/Logo';
import { Grid } from '@material-ui/core';
import ProfileInvestigadorCopy from '../../shared/containers/CentrosProfileInvestigador';
import { centros as centros_pdf } from '../../data/index';
import { centros_corfo } from '../../data/index'

//import ProfileInvestigador from '../Profile'
//import dummy from '../config/investigadorDummy.json'

Modal.setAppElement('#root');

const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '50%',
      transform             : 'translate(-50%, -50%)'
    }
}

export default class CentrosProfile extends Component {
    constructor () {
        super();
        this.state = {
          showModal: false,
          showModalProfile:false,
          selectedInvestigador:{}
        };
        
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleOpenProfileModal = this.handleOpenProfileModal.bind(this);

        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleCloseProfileModal = this.handleCloseProfileModal.bind(this);

        this.publicaciones = React.createRef();

        this.triggerChildAlert = this.triggerChildAlert.bind(this);
    }

    handleOpenModal () {
        this.setState({ showModal: true });
    }

    handleOpenProfileModal(selectedUser){
        if(!selectedUser.rut){
            return;
            //if the rut doesnt exist we dont open or set anything
        }
        this.setState( { selectedInvestigador: selectedUser } )
        this.setState( { showModalProfile: true } )
    }
      
    handleCloseModal () {
        this.setState({ showModal: false });
    }

    handleCloseProfileModal(){
        this.setState( { showModalProfile: false } )
    }

      triggerChildAlert = (index, rut) => {
        if(this.publicaciones.current === null){
            return;
        }
        console.log(index+'-------- rut:'+rut);
        if(index===2){
            this.publicaciones.current.getPublicaciones(rut);
        }
      };
    render() {
        const printFicha = ( actualCentroName ) => {
            for (let indice = 0; indice < centros_pdf.length; indice++) {
                const centroPDF= centros_pdf[indice];
                if( actualCentroName.toLowerCase() === centroPDF.name.toLowerCase() ){
                    return ( <a className="link" target="_blank"  rel="noopener noreferrer" href={centroPDF.url}> ver ficha </a>  )
                }
                
            }
        }
        return (
            <div>
                <div onClick={this.handleOpenModal} 
                    className="btn-ver-mas"
                >Ver más
                </div>
                <Modal 
                    isOpen={this.state.showModal}
                    contentLabel="Modal"
                    style={customStyles}
                    onRequestClose={this.handleCloseModal}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                >   
                    <div className="modal-header">
                        <button 
                            onClick={this.handleCloseModal}
                            className="btn-header"
                        >
                            volver
                        </button>
                        <div className="modal-header-logo">
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid
                                    container
                                    item
                                    xs={7}
                                >
                                    <Logo />

                                </Grid>
                            </Grid>
                        </div>

                        
                    </div>

                    <div className="modal-title">
                        <h2 className="modal-title__name ">
                            <a className='link' href={this.props.data.link_centro?.raw || null} rel="noopener noreferrer" target="_blank">{ this.props.data.nombre_centro?.raw } </a> 
                        </h2>
                    </div>
                    
                    <div className="modal-body">
                        <div className="modal-profile">
                            <ul className="list-profile">
                                <li>
                                    <span>
                                        <b style={{textTransform: 'capitalize'}} dangerouslySetInnerHTML={{__html: constructName(this.props.data)}}></b>
                                    </span>
                                </li>
{/*                                 <li>
                                    <span dangerouslySetInnerHTML={{__html: this.props.data.universidad?.snippet}}></span>
                                </li> */}
                                <li>
                                    <span dangerouslySetInnerHTML={{__html: this.props.data.centro?.snippet}}></span>
                                </li>
                            </ul>
                        </div>
                        <div className="modal-tabs">
                            <Tabs >
                                <TabList>
                                    <Tab>
                                        <b className="tab-title">Overview</b>
                                    </Tab>
                                    <Tab>
                                        <b className="tab-title">Equipo</b>
                                    </Tab>
                                    <Tab >
                                        <b className="tab-title">Investigación</b>
                                    </Tab>
                                    <Tab >
                                        <b className="tab-title">Publicaciones</b>
                                    </Tab>
                                    <Tab>
                                        <b className="tab-title">Proyectos</b>
                                    </Tab>
                                    <Tab>
                                        <b className="tab-title">Partners</b>
                                    </Tab>
                                    <Tab>
                                        <b className="tab-title">Equipamiento</b>
                                    </Tab>

{                                    <Tab>
                                        <b className="tab-title">Servicios</b>
                                    </Tab>}
                                </TabList>

                                {/* Overview */}
                                <TabPanel> 
                                    {/*}
                                    <div>
                                        <h4>Nombre</h4>
                                        <span dangerouslySetInnerHTML={{__html: this.props.data.nombre_centro?.snippet}}></span>
                </div>  */  }
                                    <div>
                                        <h4>Descripción</h4>
                                        {
                                            this.props.data.descripcion.snippet === null || this.props.data.descripcion.snippet === ""
                                            ? ""
                                            : <span dangerouslySetInnerHTML={{__html: ` ${this.props.data.descripcion?.raw}`}}></span>
                                        }
                                        <br/>
                                    </div>
                                    <div>
                                        <h4>Propuesta de Valor</h4>
                                        {
                                            this.props.data.propuesta_valor.snippet === null || this.props.data.propuesta_valor.snippet === ""
                                            ? ""
                                            : <span dangerouslySetInnerHTML={{__html: ` ${this.props.data.propuesta_valor?.raw}`}}></span>
                                        }
                                    </div>
                                    <div>
                                        <h4>Ventajas Competitivas</h4>
                                        {
                                            this.props.data.ventajas_competitivas.snippet === null || this.props.data.ventajas_competitivas.snippet === ""
                                            ? ""
                                            : <span dangerouslySetInnerHTML={{__html: ` ${this.props.data.ventajas_competitivas?.raw}`}}></span>
                                        }
                                    </div>
                                    <div>
                                        {
                                            this.props.data.universidad?.snippet.toLowerCase() !== "unab" && (
                                                <>
                                                    <h4>Ficha del Centro </h4>
                                                        { 
                                                            printFicha(this.props.data.nombre_centro.snippet.replaceAll("<em>","").replaceAll("</em>",""))
                                                        }
                                                </>
                                            )
                                        }
                                    </div>
                                    {
                                        centros_corfo.map( centro =>{
                                            if( ( centro.nombre.toLowerCase() === this.props.data.nombre_centro?.raw.toLowerCase() ) && centro.universidad === this.props.data.universidad?.raw ){
                                                return (
                                                    <div key={ centro.nombre }>
                                                        <a className='link link--corfo' href={centro.url} rel="noopener noreferrer" target="_blank">Este Centro pertenece a I+D inscrito en registro CORFO</a>
                                                    </div>
                                                )
                                            } else {
                                                return <></>
                                            }
                                            
                                        })
                                    }
                                    <div>
                                        <h4>Expertise</h4>
                                        <ul>
                                            {
                                                this.props.data.expertice?.raw.map( ( experticeJSON, index ) =>{
                                                    const expertice = JSON.parse( experticeJSON );
                                                    return (
                                                        <li key={ index }> { expertice.expertice } </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </TabPanel>
                                
                                {/* Equipo */}
                                <TabPanel>
                                    <div className="tabs-team">
                                        {
                                            this.props.data.investigadores.raw.map( (element, index) => {
                                                let elementJSON = JSON.parse(element, (key, value) => {
                                                    if (key === 'tipo_investigador' || key === 'investigador') {
                                                      return value?.toLowerCase();
                                                    }
                                                    return value;
                                                })
                                                return (
                                                    <button 
                                                        type="button" 
                                                        key={index}
                                                        className="teamButton"
                                                        onClick={ ()=> ( this.handleOpenProfileModal(elementJSON) ) } 
                                                    >
                                                        <span className="modal-body-a teamButton__title">
                                                            {elementJSON['investigador']}
                                                        </span>
                                                        <span className="teamButton__position">
                                                            {elementJSON['tipo_investigador']}
                                                        </span>
                                                    </button>
                                                )
                                            })
                                        }   
                                    </div>
                                </TabPanel>
                                {/* Investigacion */}
                                <TabPanel>
                                    <div>
                                        {
                                            this.props.data.lineainvestigacion.raw.map( (element, index) => {
                                                const investigacionWithoutRNJSON = element
                                                let investigacion = JSON.parse(investigacionWithoutRNJSON)
                                                return (
                                                    <div className="paddingLeft-20" key={index}>
                                                        <div className="modal-body-a">
                                                            {
                                                            investigacion['nombre_linea']?.split("\n").map(function(item, idx) {
                                                                return (
                                                                    <>
                                                                        {item}
                                                                        <br />
                                                                    </>
                                                                 )
                                                            })
                                                            }

                                                        </div>
                                                        <div>
                                                            <span>
                                                                {
                                                                    investigacion['desarrollo_tecnico']?.split("\n").map(function(item, idx) {
                                                                        return (
                                                                            <>
                                                                                {item}
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span>
                                                                {
                                                                    investigacion['aplicaciones']?.split("\n").map(function(item, idx) {
                                                                        return (
                                                                            <>
                                                                                {item}
                                                                                <br />
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </span>
                                                        </div>
                                                        <br></br>
                                                    </div>
                                                )
                                            })
                                        }                                                                    
                                    </div>
                                    
                                </TabPanel>

                                {/* Publicaciones */}
                                <TabPanel>
                                    <div>
                                        {
                                            this.props.data.publicaciones.raw.map( (element, index) => {
                                                let elementJSON = JSON.parse(element)
                                                return (
                                                    <div className="paddingLeft-20" key={index}>
                                                        <div className="uppercase modal-body-a">{elementJSON['nombre']}</div>
                                                        <div>
                                                            <span>{elementJSON['autor']}</span>
                                                        </div>
                                                        <div>
                                                            <span>{elementJSON['anio']}</span>
                                                        </div>
                                                        <br></br>
                                                    </div>
                                                )
                                            })
                                        }                                                                    
                                    </div>
                                    
                                </TabPanel>

                                {/* Proyectos */}
                                <TabPanel>

                                    <div>
                                        {
                                            this.props.data.proyectos.raw.map( (element, index) => {
                                                let elementJSON = JSON.parse(element)
                                                return (
                                                    <div className="paddingLeft-20" key={index}>
                                                        <div className="uppercase modal-body-a">{elementJSON['nombre']}</div>
                                                        <div>
                                                            <span>Tipo de financiamiento {elementJSON['institucion_financia']}</span>
                                                        </div>
                                                        <div>
                                                            <span>Investigador Principal: {elementJSON['investigador_principal']}</span>
                                                        </div>
                                                        <br></br>
                                                    </div>
                                                )
                                            })
                                        }                                                                    
                                    </div>
                                </TabPanel>

                                {/* Partners */}
                                <TabPanel>
                                    <ul>
                                        {
                                            this.props.data.partners?.raw.map( ( partnerJSON ) =>{
                                                const { partner } = JSON.parse( partnerJSON );
                                                return (
                                                    <li key={ partner }> { partner } </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </TabPanel>

                                {/* Equipamiento */}
                                <TabPanel>
                                        { 
                                            this.props.data.equipamiento===null || this.props.data.equipamiento.snippet===null?
                                            <div></div>:
                                            this.props.data.equipamiento.raw.map( (element, index) => {
                                                let elementJSON = JSON.parse(element)
                                                return (
                                                        <div key={index}>
                                                            <div className="paddingLeft-20" key={index}>
                                                                <div className="uppercase modal-body-a">{elementJSON['equipo']}</div>
                                                                <div>
                                                                    <span>Descripci&oacute;n: {elementJSON['descripcion']}</span>
                                                                </div>
                                                                <div>
                                                                    <span>Marca: {elementJSON['marca']}</span>
                                                                </div>
                                                                <br></br>
                                                            </div>
                                                            <br></br>
                                                        </div>
                                                    
                                                )
                                            })
                                        }
                                    
                                </TabPanel>

                                {/* Servicios */}        
                                <TabPanel>
                                        {
                                            this.props.data.servicios?.raw && JSON.parse( this.props.data.servicios.raw).map( ( { nombre,descripcion,laboratorio }, index ) => {
                                                return (
                                                    <div key={ index }>
                                                        {
                                                            nombre && (
                                                                <>
                                                                    <h4>
                                                                    { nombre }
                                                                    </h4>
                                                                </>
                                                            )
                                                        }                      
                                                        {
                                                            descripcion && (
                                                                <>
                                                                    <p>{ descripcion }</p>
                                                                </>
                                                            )
                                                        }
                                                        
                                                        {
                                                            laboratorio && ( <span> { laboratorio }</span> )
                                                        }
                                                    </div>
                                                )
                                            } )
                                        }
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                    {/* <div dangerouslySetInnerHTML={{__html: JSON.stringify(this.props.data)}}></div> */}
                </Modal>

                 <Modal 
                    isOpen={this.state.showModalProfile}
                    contentLabel="Modal"
                    style={customStyles}
                    onRequestClose={this.handleCloseProfileModal}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                >
                    <div className="modal-header">
                        <button 
                            onClick={this.handleCloseProfileModal}
                            className="btn-header"
                        >
                            volver
                        </button>
                        <div className="modal-header-logo">
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid
                                container
                                item
                                xs={7}
                            >
                                <Logo />

                            </Grid>
                        </Grid>
                        </div>

                        
                    </div>
                    <ProfileInvestigadorCopy rut={ this.state.selectedInvestigador.rut } />
                </Modal>
            </div>
        )
    }
}